<sd-modal>
  <div class="wrapper">
    <h4>Адрес самовывоза</h4>
    <div class="list-wrapper">
      <sd-pickup-user-shop-list></sd-pickup-user-shop-list>
    </div>
  </div>
</sd-modal>
